var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"id":"core-footer","absolute":"","height":"82"}},[_c('div',{staticClass:"footer-items"},_vm._l((_vm.links),function(link){return _c('span',{key:link.name},[_c('a',{staticClass:"tertiary--text footer-links",attrs:{"href":link.Link}},[_vm._v(_vm._s(link.name))])])}),0),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }